// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__20h9s","left":"StickyBox_left__-Sype","right":"StickyBox_right__3Y0ht"};